import React, { Component } from "react";
import Collapsible from "react-collapsible";

class Squeezebox extends Component {
    constructor(props) {
        super(props);
        const isOpen = props.isOpen === "true" ? true : false;
        this.state = { open: isOpen };
        this.toggleCollapsible = this.toggleCollapsible.bind(this);
    }

    componentDidMount() {
        const { isUsp } = this.props;

        isUsp &&
            document
                .getElementById("usp-container")
                .addEventListener("click", () => {
                    this.toggleCollapsible(true);
                });
    }

    toggleCollapsible(open) {
        this.setState({ open });
    }

    render() {
        const { title, html } = this.props;
        
        return (
            <Collapsible
                trigger={title}
                triggerTagName="h2"
                transitionTime={200}
                easing="ease"
                classParentString="squeezebox"
                open={this.state.open}
                onOpening={() => this.toggleCollapsible(true)}
                onClosing={() => this.toggleCollapsible(false)}
            >
                {html && (
                    <div
                        className="squeezebox__html"
                        dangerouslySetInnerHTML={{ __html: html }}
                    ></div>
                )}
            </Collapsible>
        );
    }
}

export default Squeezebox;
